import { css } from "@stubhub/broadway-foundation/css";

export const iconButtonLinkColor = css({
  backgroundColor: "bg.dark",
});
